import { render, staticRenderFns } from "./CountrySchemeDetailCard.vue?vue&type=template&id=ec6ee62e"
import script from "./CountrySchemeDetailCard.vue?vue&type=script&lang=js"
export * from "./CountrySchemeDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports